var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6003 19.5791C15.727 19.4465 15.8275 19.289 15.8961 19.1157C15.9647 18.9423 16 18.7565 16 18.5688C16 18.3812 15.9647 18.1953 15.8961 18.022C15.8275 17.8486 15.727 17.6912 15.6003 17.5586L10.2972 11.9988L15.6003 6.43891C15.8559 6.17098 15.9994 5.80759 15.9994 5.42868C15.9994 5.04977 15.8559 4.68638 15.6003 4.41845C15.3447 4.15052 14.9981 4 14.6367 4C14.2753 4 13.9287 4.15052 13.6732 4.41845L7.3997 10.9957C7.273 11.1283 7.17248 11.2857 7.10389 11.4591C7.0353 11.6324 7 11.8182 7 12.0059C7 12.1936 7.0353 12.3794 7.10389 12.5528C7.17248 12.7261 7.273 12.8836 7.3997 13.0161L13.6732 19.5934C14.1925 20.1379 15.0673 20.1379 15.6003 19.5791Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/Left.21d591e990e97a4278f987c5893cd2d4.svg";
export { ForwardRef as ReactComponent };